import { NgClass } from '@angular/common';
import { Component, computed, HostListener, inject, input, Signal } from '@angular/core';
import { mgcIconArrowDownRegular } from '@sb/mgc-icons';

import { IconComponent, IconRegistry } from '../icon';
import { SB_TABLE } from './table-token';
import { TableComponent } from './table.component';
import { TableCellDirective } from './table.directives';
import { defaultTableSortDirection } from './table.helpers';
import { TableSortDirection } from './table.model';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'th[sb-table-header-sort]',
  standalone: true,
  exportAs: 'sbTableHeaderSort',
  imports: [IconComponent, NgClass],
  styleUrl: './table-header-sort.component.scss',
  host: {
    '[attr.aria-sort]': 'ariaSort()',
  },
  templateUrl: './table-header-sort.component.html',
})
export class TableHeaderSortComponent<T extends Record<string, any>> extends TableCellDirective {
  private table? = inject<TableComponent<T>>(SB_TABLE, { optional: true });

  sortable = input<boolean>(true);
  sortKey = input.required<keyof T>();

  direction: Signal<TableSortDirection> = computed(() => {
    return this.table?.sortDirection() ?? defaultTableSortDirection;
  });

  ariaSort: Signal<'none' | 'ascending' | 'descending'> = computed(() => {
    const sortKey = this.sortKey();
    const activeSort = this.table?.sortKey();
    if (sortKey !== activeSort) {
      return 'none';
    }
    return this.direction() === 'asc' ? 'ascending' : 'descending';
  });

  sorted: Signal<boolean> = computed(() => {
    const sortKey = this.sortKey();
    const activeSort = this.table?.sortKey();
    return sortKey === activeSort;
  });

  constructor() {
    super();

    inject(IconRegistry).registerIcons([mgcIconArrowDownRegular]);
  }

  @HostListener('click')
  onClick() {
    if (!this.sortable()) {
      return;
    }

    const sortKey = this.sortKey();
    this.table?.changeSort(sortKey);
  }
}
